import React from 'react';

import UserForm from './UserForm';

const StaffOps = () => <UserForm />;

export default StaffOps;
